import { z } from 'zod';
/**
 * Per the fan-platform monetisation flow — operator-defined campaigns
 * that grant fans a one-time reward (point grant) when they meet a
 * trigger condition. Examples:
 *
 *   - 註冊送 50 點   trigger='signup'
 *   - 首次儲值送 100 點  trigger='first-topup'
 *   - 任意消費送 20 點  trigger='any-spend'
 *
 * Reward is granted at claim time (fan-initiated, idempotent via the
 * claims table). The trigger condition is re-verified at claim time
 * — we don't rely on side-effects in other handlers.
 */
export const ActivityTriggerEnum = z.enum(['signup', 'first-topup', 'any-spend']);
export const ActivityRewardSchema = z
    .object({
    type: z.enum(['platform-points', 'group-points']),
    amount: z.number().int().min(1).max(10000),
    groupId: z.string().uuid().optional(),
})
    .superRefine((r, ctx) => {
    if (r.type === 'group-points' && !r.groupId) {
        ctx.addIssue({ code: 'custom', path: ['groupId'], message: 'group-points reward needs groupId' });
    }
    if (r.type === 'platform-points' && r.groupId) {
        ctx.addIssue({ code: 'custom', path: ['groupId'], message: 'platform-points reward must not have groupId' });
    }
});
export const ActivityPopupConfigSchema = z.object({
    ctaLabel: z.string().min(1).max(30).default('立即領取'),
    ctaAction: z.enum(['topup', 'browse', 'dismiss']).default('dismiss'),
});
export const ActivitySchema = z.object({
    activityId: z.string().uuid(),
    customerId: z.string().min(1).max(128),
    name: z.string().min(1).max(80),
    description: z.string().max(500).default(''),
    startsAt: z.string().datetime(),
    endsAt: z.string().datetime(),
    trigger: ActivityTriggerEnum,
    reward: ActivityRewardSchema,
    popupConfig: ActivityPopupConfigSchema,
    enabled: z.boolean().default(true),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const ActivityClaimSchema = z.object({
    fanId: z.string().min(1).max(128),
    activityId: z.string().uuid(),
    claimedAt: z.string().datetime(),
    rewardAmount: z.number().int().min(1),
    rewardType: z.enum(['platform-points', 'group-points']),
    rewardGroupId: z.string().uuid().optional(),
});
